import { StateCreator } from 'zustand'

import EStoreStateKeys from '~/models/store'

type TPortalAlertsDefinition = {
  dismissedAlertsIds: string[]
}

type TPortalAlerts = {
  [EStoreStateKeys.portalAlerts]: TPortalAlertsDefinition
}

export type TPortalAlertsState = TPortalAlerts & {
  dismissAlert(id: string): void
}

export const initialPortalAlertsState: TPortalAlertsDefinition = {
  dismissedAlertsIds: [],
}

const createPortalAlertsSlice: StateCreator<
  TPortalAlertsState,
  [['zustand/devtools', unknown]],
  []
> = (set) => ({
  portalAlerts: { ...initialPortalAlertsState },
  dismissAlert: (id: string) =>
    set(
      (state) => ({
        portalAlerts: {
          ...state.portalAlerts,
          dismissedAlertsIds: Array.from(
            new Set([...state.portalAlerts.dismissedAlertsIds, id]),
          ),
        },
      }),
      undefined,
      {
        type: 'dismissAlert',
        id,
      },
    ),
})

export default createPortalAlertsSlice
